import { render, staticRenderFns } from "./template-block-card.vue?vue&type=template&id=5779185a&scoped=true"
import script from "./template-block-card.vue?vue&type=script&lang=js"
export * from "./template-block-card.vue?vue&type=script&lang=js"
import style0 from "./template-block-card.vue?vue&type=style&index=0&id=5779185a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779185a",
  null
  
)

export default component.exports